<template>
  <tk-container class="filters" :status="status">
    <tkui-header center slot="header">
      <tk-icon slot="left-menu" @click.native="back">Return</tk-icon>
      滤芯状态
    </tkui-header>
    <div class="filter" v-if="filterCounter.count1">
      <tk-flex between>
        <div>
          <p class="state" :style="{'color': getColor(filterCounter.num1)}">{{getText(filterCounter.num1)}}</p>
          <p class="type">5μmpp棉</p>
        </div>
        <tkui-button class="raised primary small" @click.native="reset('1', filterCounter.count1)">重置</tkui-button>
      </tk-flex>
      <vue-slider :bgStyle="{'background': '#F1F5F8'}" :processStyle="{'background': getColor(filterCounter.num1)}" v-model="filterCounter.num1" :max="filterCounter.count1" :tooltip=false :clickable=false :dot-size=0></vue-slider>
      <tk-flex between>
        <p class="surplus">剩余{{filterCounter.num1}}天</p>
        <p class="cycle">更换周期{{filterCounter.count1}}天</p>
      </tk-flex>
    </div>
    <div class="filter" v-if="filterCounter.count2 && secondFilter">
      <tk-flex between>
        <div>
          <p class="state" :style="{'color': getColor(filterCounter.num2)}">{{getText(filterCounter.num2)}}</p>
          <p class="type">{{secondFilter}}</p>
        </div>
        <tkui-button class="raised primary small" @click.native="reset('2', filterCounter.count2)">重置</tkui-button>
      </tk-flex>
      <vue-slider :bgStyle="{'background': '#F1F5F8'}" :processStyle="{'background': getColor(filterCounter.num2)}" v-model="filterCounter.num2" :max="filterCounter.count2" :tooltip=false :clickable=false :dot-size=0></vue-slider>
      <tk-flex between>
        <p class="surplus">剩余{{filterCounter.num2}}天</p>
        <p class="cycle">更换周期{{filterCounter.count2}}天</p>
      </tk-flex>
    </div>
    <div class="filter" v-if="filterCounter.count3">
      <tk-flex between>
        <div>
          <p class="state" :style="{'color': getColor(filterCounter.num3)}">{{getText(filterCounter.num3)}}</p>
          <p class="type">1μmpp棉</p>
        </div>
        <tkui-button class="raised primary small" @click.native="reset('3', filterCounter.count3)">重置</tkui-button>
      </tk-flex>
      <vue-slider :bgStyle="{'background': '#F1F5F8'}" :processStyle="{'background': getColor(filterCounter.num3)}" v-model="filterCounter.num3" :max="filterCounter.count3" :tooltip=false :clickable=false :dot-size=0></vue-slider>
      <tk-flex between>
        <p class="surplus">剩余{{filterCounter.num3}}天</p>
        <p class="cycle">更换周期{{filterCounter.count3}}天</p>
      </tk-flex>
    </div>
    <div class="filter" v-if="filterCounter.count4 && fourthFilter">
      <tk-flex between>
        <div>
          <p class="state" :style="{'color': getColor(filterCounter.num4)}">{{getText(filterCounter.num4)}}</p>
          <p class="type">{{fourthFilter}}</p>
        </div>
        <tkui-button class="raised primary small" @click.native="reset('4', filterCounter.count4)">重置</tkui-button>
      </tk-flex>
      <vue-slider :bgStyle="{'background': '#F1F5F8'}" :processStyle="{'background': getColor(filterCounter.num4)}" v-model="filterCounter.num4" :max="filterCounter.count4" :tooltip=false :clickable=false :dot-size=0></vue-slider>
      <tk-flex between>
        <p class="surplus">剩余{{filterCounter.num4}}天</p>
        <p class="cycle">更换周期{{filterCounter.count4}}天</p>
      </tk-flex>
    </div>
    <div class="filter" v-if="filterCounter.count5">
      <tk-flex between>
        <div>
          <p class="state" :style="{'color': getColor(filterCounter.num5)}">{{getText(filterCounter.num5)}}</p>
          <p class="type">后置碳</p>
        </div>
        <tkui-button class="raised primary small" @click.native="reset('5', filterCounter.count5)">重置</tkui-button>
      </tk-flex>
      <vue-slider :bgStyle="{'background': '#F1F5F8'}" :processStyle="{'background': getColor(filterCounter.num5)}" v-model="filterCounter.num5" :max="filterCounter.count5" :tooltip=false :clickable=false :dot-size=0></vue-slider>
      <tk-flex between>
        <p class="surplus">剩余{{filterCounter.num5}}天</p>
        <p class="cycle">更换周期{{filterCounter.count5}}天</p>
      </tk-flex>
    </div>
  </tk-container>
</template>

<script>
  import vueSlider from 'vue-slider-component'
  import moment from 'moment'
  export default {
    data () {
      return {
        secondFilter: '',
        fourthFilter: '',
        filterCounter: {
          num1: 0,
          count1: 0,
          num2: 0,
          count2: 0,
          num3: 0,
          count3: 0,
          num4: 0,
          count4: 0,
          num5: 0,
          count5: 0
        },
        status: false,
        filters: ['firstCotton', 'compressedCarbon', 'secondCotton', 'ro', 'backCarbon'],
        today: Date.now(),
        ratio: 0.1,
        filterId: null
      }
    },
    computed: {
      machine () {
        return this.$store.state.machine || {}
      },
      statusData () {
        return this.$store.state.status || {}
      }
    },
    watch: {
      async isChange () {
        let status = this.isChange
        if (JSON.stringify(status) === '{}' || !this.statusData.objectId) return
        let change = false
        for (let key in status) {
          if (status[key]) {
            change = true
            break
          }
        }
        let text = change ? 'change' : 'normal'
        await this.$tkParse.put(`/classes/status/${this.statusData.objectId}`, {
          'filterStatus': text
        })
      }
    },
    created () {
      this.getFilter()
    },
    methods: {
      async getFilter () {
        try {
          this.status = 'loading'
          let res = await this.$tkParse.getList('/classes/filter', {
            'params': {
              'where': {
                'machine': this.machine.objectId
              }
            }
          })
          let filters = res[0]
          if (filters) {
            this.secondFilter = filters.compressedCarbon && filters.compressedCarbon.name ? filters.compressedCarbon.name === 'activatedCarbon' ? '活性炭' : '0.01μm超滤' : ''
            this.fourthFilter = filters.ro && filters.ro.name ? filters.ro.name === 'ro' ? 'RO膜' : '0.01μm超滤' : ''
            this.filterId = filters.objectId
            this.filters.forEach((item, index) => {
              this.countSurplus(filters[item], index + 1)
            })
          }
          this.status = false
        } catch (e) {
          this.status = 'error'
        }
      },
      countSurplus (obj, index) {
        if (obj && obj.start && obj.totalTime) {
          let diffTime = moment().diff(moment(obj.start), 'days')
          diffTime = diffTime < 0 ? 0 : diffTime
          this.filterCounter['count' + index] = Number(obj.totalTime)
          this.filterCounter['num' + index] = Number(obj.totalTime) - diffTime < 0 ? 0 : Number(obj.totalTime) - diffTime
        }
      },
      back () {
        this.$back()
      },
      getColor (num) {
        if (num <= 5) return '#F41728'
        if (num > 5 && num <= 15) return '#F4E00D'
        return '#0091FF'
      },
      getText (num) {
        return num <= 15 ? '需更换' : '正常'
      },
      async reset (index, days) {
        let filters = this.filterCounter
        if (filters['num' + index] === filters['count' + index]) return
        try {
          this.status = 'waiting'
          let content = {
            [this.filters[index - 1]]: {
              'start': moment().toISOString(),
              'remaining': days
            }
          }
          await this.$tkParse.put(`/classes/filter/${this.filterId}`, content)
          filters['num' + index] = filters['count' + index]
          this.status = false
          this.$tkGlobal.toast.add('复位成功')
        } catch (e) {
          this.status = false
          this.$tkGlobal.toast.add('复位失败')
        }
      }
    },
    components: {
      vueSlider
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .filters{
    .filter{
      background: #ffffff;
      padding: 15px;
      margin-bottom: 10px;
      .state{
        color: #0091FF;
        font-size: 14px;
        font-weight: 700;
      }
      .warn{
        color: #F4E00D
      }
      .type{
        color: #999999;
        font-size: 12px;
        margin-bottom: 8px;
      }
      .surplus{
        color: #333333;
        font-size: 12px;
        margin-top: 5px;
      }
      .cycle{
        color: #999999;
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/detail/filter.vue